import styled from "styled-components";
import KitObject from "../../../assets/images/pluvaIonLanding/top_kit_object.jpg";
import IonLogoText from "../../../assets/svg/ion_logo_text.svg";
import { YoutubeSection } from "../../../components/common/video/YoutubeSection";
import { useScrollReveal } from "../hooks/useScrollReveal";
import { ionGradientText } from "../styles/ionGradientText";
import { revealDelayStyle } from "../styles/scrollReveal";

export const TopSection = () => {
  const titleReveal = useScrollReveal(0.3);

  return (
    <Container>
      <YoutubeWrapper>
        <YoutubeSection youtubeUrl="https://youtu.be/8SFu31FKXTU" />
      </YoutubeWrapper>

      <TextSection ref={titleReveal.ref}>
        <LogoWrapper $visible={titleReveal.isVisible} $delay={0}>
          <img src={IonLogoText} alt="pluva ion" width={118} height={19} />
        </LogoWrapper>

        <Title $visible={titleReveal.isVisible} $delay={200}>
          {"베테랑의 숙련도에\n여유를 더하다"}
        </Title>

        <SubTitle $visible={titleReveal.isVisible} $delay={500}>
          {"플루바 아이온 자율주행키트"}
        </SubTitle>
      </TextSection>

      <KitImageWrapper>
        <img
          src={KitObject}
          alt="플루바 아이온 자율주행키트 구성품"
          loading="lazy"
        />
      </KitImageWrapper>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;

  background-color: #000000;
`;

const YoutubeWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-top: 65px;
  margin-bottom: 60px;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 72px;
    background: linear-gradient(to bottom, #000000 0%, transparent 100%);
    z-index: 1;
    pointer-events: none;
  }
`;

const TextSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  padding: 40px 24px 48px;
`;

const LogoWrapper = styled.div<{ $visible: boolean; $delay: number }>`
  display: flex;
  align-items: center;
  justify-content: center;

  ${revealDelayStyle}
`;

const Title = styled.h1<{ $visible: boolean; $delay: number }>`
  text-align: center;
  white-space: pre-line;

  font-family: Pretendard;

  font-style: normal;
  font-weight: 700;
  line-height: 130%;

  ${ionGradientText}
  ${revealDelayStyle}
`;

const KitImageWrapper = styled.div`
  width: 100%;

  img {
    width: 100%;
    display: block;
    object-fit: cover;
  }
`;

const SubTitle = styled.p<{ $visible: boolean; $delay: number }>`
  color: #ffffff;
  text-align: center;
  vertical-align: middle;

  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%;
  letter-spacing: 0px;

  ${revealDelayStyle}
`;
